import * as P from "fp-ts-routing";

export type DesignRoute = {};

export const designPageMatch = P.lit("design");
